<template>
  <div class="task-control task-directions" v-if="task && task.code" data-qid="task-directions">
    <div class="task-control__label"><font-awesome-icon icon="info-circle" class="mr-1"/>{{ $t('tasks.directions.title') }}</div>
    <div class="task-control__text">{{ text }}</div>
  </div>
</template>

<script>
// What the user needs to do in an update or validation task, per kind of task (US 9478)
export default {
  name: 'TaskDirections',
  props: {
    task: { type: Object, default: null },
    // 'update' or 'validation': the fallback when a kind of task has no directions of its own
    kind: { type: String, default: 'update' }
  },
  computed: {
    text() {
      const key = 'tasks.directions.' + this.task.code;
      return this.$te(key) ? this.$t(key) : this.$t('tasks.directions.' + this.kind + '_default');
    }
  }
}
</script>
